module.exports = __webpack_public_path__ + "img/new_21.43ed2058.jpg";